import {ControlledFormField} from '@hconnect/common/types'
import {useTheme, useMediaQuery} from '@mui/material'
import {FieldValues, Path} from 'react-hook-form'

import {useWidgetTranslation} from '../../hooks'
import {YesNoFormValue} from '../../types'

import {RadioButtonField} from './RadioButtonField'

type YesNoFieldProps<TField extends FieldValues> = ControlledFormField<TField> & {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, value: YesNoFormValue) => void
}

export const YesNoField = <TField extends FieldValues>({
  label,
  name,
  control,
  disabled,
  readOnly,
  onChange
}: YesNoFieldProps<TField>) => {
  const {t} = useWidgetTranslation()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const yesNoItemOptions = [
    {value: YesNoFormValue.YES, label: t('label.yes')},
    {value: YesNoFormValue.NO, label: t('label.no')}
  ]

  return (
    <RadioButtonField
      label={label}
      options={yesNoItemOptions}
      disabled={disabled}
      readOnly={readOnly}
      name={name as Path<TField>}
      control={control}
      row={!isSmall}
      onChange={onChange}
    />
  )
}
